import * as React from "react";
import styles from "./dashboard.module.scss";

const Dashboard = (): React.JSX.Element => (
  <>
    <div className={styles.dashboardContainer}>Dashboard</div>
  </>
);
export default Dashboard;
